import { Switch } from '@fluentui/react-components';
import type { TableRecord } from '@powerportalspro/core';
import { RecordContext, useT } from '@powerportalspro/react';
import { ColumnDisplayValue } from '@powerportalspro/react-fluent';
import { useState } from 'react';

// Localization namespace — reuses the Blazor demo's
// `DisplayValuesChoiceColorsDemo` keys so both stacks read from the same JSON.
const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Viewers.DisplayValues.DisplayValuesChoiceColorsDemo';

// On a page the values read a <RecordContext> that loads its record from Dataverse. This record is
// handed in through `loadedRecord` instead, so the sample shows its colors without depending on data.
const RECORD_ID = '00000000-0000-0000-0000-00000000000c';
const record: TableRecord = {
  id: RECORD_ID,
  tableName: 'ppp_democustomtable',
  properties: {
    ppp_favoritecolor: { $type: 11, value: 100000001 },
    ppp_favoritecolors: { $type: 40, value: [{ value: 100000000 }, { value: 100000008 }, { value: 100000006 }] },
  },
  formattedValues: { ppp_favoritecolor: 'Blue', ppp_favoritecolors: 'Red; Green; White' },
  isDirty: false,
};

export function DisplayValuesChoiceColorsSample() {
  const t = useT();
  const [displayChoiceColors, setDisplayChoiceColors] = useState(true);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Switch
        label={t(`${STRINGS_BASE}.display-choice-colors`)}
        checked={displayChoiceColors}
        onChange={(_, d) => setDisplayChoiceColors(d.checked)}
      />
      <RecordContext
        table="ppp_democustomtable"
        id={RECORD_ID}
        loadedRecord={record}
        warnOnUnsavedChanges={false}
      >
        <ColumnDisplayValue
          columnName="ppp_favoritecolor"
          label={t(`${STRINGS_BASE}.favorite-color-label`)}
          displayChoiceColors={displayChoiceColors}
        />
        <ColumnDisplayValue
          columnName="ppp_favoritecolors"
          label={t(`${STRINGS_BASE}.favorite-colors-label`)}
          displayChoiceColors={displayChoiceColors}
        />
      </RecordContext>
    </div>
  );
}
